import { render, staticRenderFns } from "./personageIndex.vue?vue&type=template&id=a29748a0&"
import script from "./personageIndex.vue?vue&type=script&lang=js&"
export * from "./personageIndex.vue?vue&type=script&lang=js&"
import style0 from "./personageIndex.vue?vue&type=style&index=0&id=a29748a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports